import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import OrganizationUsers from '../../../../PublicView/Pages/MyOrganizations/OrganizationUsers';

class ManageUsersForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrganization: {}
    };
  }

  componentDidMount() {
    console.log('ManageUsersForm', this.props.selectedOrganization);
    const selectedOrganization = this.props.selectedOrganization;
    selectedOrganization.organizationName = this.props.selectedOrganization.OrganizationName;
    selectedOrganization.organizationId = this.props.selectedOrganization.OrganizationId;
    this.setState({
      selectedOrganization: selectedOrganization
    }, () => console.log(this.state));
  }

  render() {
    return (
      <Dialog onClose={this.props.cancel}>
        <h2 className="adjust-dist-title2">Manage Users</h2>

        {this.state.selectedOrganization.organizationId &&
          <OrganizationUsers selectedOrganization={this.state.selectedOrganization}/>
        }
        
        <div className="user-form">
          <DialogActionsBar>
            <div className="adjust-btns">
              <div className="form-group form-group--org">
                <button className="admin-k-button" onClick={this.props.cancel}>
                  <i className="fas fa-times"></i>
                  <span>CANCEL</span>
                </button>
              </div>
            </div>
          </DialogActionsBar>
        </div>
      </Dialog>
    );
  }
}

export default ManageUsersForm;
